var map = {
	"./COIN.png": 47208,
	"./CRY.png": 51799,
	"./GIFTSHARD.png": 40393,
	"./LGCOIN.png": 76100,
	"./LGSPINS.png": 2176,
	"./PASS.png": 32028,
	"./SPINS.png": 87415,
	"./USDT.png": 17108,
	"./airdrop-box-img.png": 52502,
	"./airdrop-intro-bg.jpg": 55789,
	"./avatar/body/0.png": 20506,
	"./avatar/body/1.png": 68290,
	"./avatar/body/10.png": 17734,
	"./avatar/body/11.png": 81984,
	"./avatar/body/12.png": 70939,
	"./avatar/body/13.png": 77371,
	"./avatar/body/14.png": 13394,
	"./avatar/body/15.png": 69540,
	"./avatar/body/16.png": 21868,
	"./avatar/body/17.png": 96636,
	"./avatar/body/18.png": 253,
	"./avatar/body/19.png": 83259,
	"./avatar/body/2.png": 89494,
	"./avatar/body/20.png": 83205,
	"./avatar/body/3.png": 93948,
	"./avatar/body/4.png": 14567,
	"./avatar/body/5.png": 50516,
	"./avatar/body/6.png": 39085,
	"./avatar/body/7.png": 16668,
	"./avatar/body/8.png": 3414,
	"./avatar/body/9.png": 64801,
	"./avatar/head/0.png": 94779,
	"./avatar/head/1.png": 97656,
	"./avatar/head/10.png": 27961,
	"./avatar/head/11.png": 37123,
	"./avatar/head/12.png": 97476,
	"./avatar/head/13.png": 39227,
	"./avatar/head/14.png": 91867,
	"./avatar/head/15.png": 82950,
	"./avatar/head/16.png": 19891,
	"./avatar/head/17.png": 86674,
	"./avatar/head/18.png": 4938,
	"./avatar/head/19.png": 15491,
	"./avatar/head/2.png": 47683,
	"./avatar/head/20.png": 11410,
	"./avatar/head/3.png": 76033,
	"./avatar/head/4.png": 67688,
	"./avatar/head/5.png": 5665,
	"./avatar/head/6.png": 65219,
	"./avatar/head/7.png": 67468,
	"./avatar/head/8.png": 50344,
	"./avatar/head/9.png": 25028,
	"./avatar/pet/1.png": 60997,
	"./avatar/pet/2.png": 20390,
	"./avatar/pet/3.png": 70497,
	"./avatar/pet/4.png": 4656,
	"./avatar/pet/5.png": 28114,
	"./avatar/pet/6.png": 39373,
	"./botcode/botcode-bg.jpg": 3493,
	"./botcode/game-banner.jpg": 20730,
	"./botcode/game-icon-bg.png": 11343,
	"./botcode/game-icon-restart.png": 40307,
	"./botcode/game-item-bg-icon.png": 61217,
	"./botcode/game-item-bg.png": 23019,
	"./botcode/game-item-ok-bg.png": 29761,
	"./botcode/game-item-select-bg.png": 97136,
	"./botcode/game-reward-bg.png": 23605,
	"./botcode/game-title-bg.png": 23594,
	"./botcode/icon-buy.png": 30930,
	"./botcode/icon-invite.png": 56299,
	"./botcode/icon-lucky.png": 64254,
	"./botcode/icon-task.png": 61332,
	"./botcode/option-bg.jpg": 14313,
	"./buySpineItemBg1.png": 99267,
	"./buySpineItemBg2-tag.png": 71666,
	"./buySpineItemBg2.png": 23474,
	"./buySpineItemBg3-tag.png": 37315,
	"./buySpineItemBg3.png": 20463,
	"./card-bg.png": 91049,
	"./center-item-bg.png": 65721,
	"./firend-intro-bg.jpg": 27476,
	"./guide/guide-icon-arrow.png": 45170,
	"./guide/guide-img-botcode.jpg": 77444,
	"./guide/guide-img-slot.jpg": 59295,
	"./guide/guide-img-turn.jpg": 64402,
	"./icon-bonus.png": 20919,
	"./icon-firend.png": 25011,
	"./icon-gift-small.png": 34664,
	"./icon-gift.png": 82043,
	"./icon-lock-small.png": 69220,
	"./icon-rank.png": 50115,
	"./icon-stock.png": 41174,
	"./icon-upgrade.png": 98094,
	"./icon/icon-account.png": 9380,
	"./icon/icon-discord.png": 848,
	"./icon/icon-dogs.png": 98726,
	"./icon/icon-extend.png": 73076,
	"./icon/icon-giftshare.png": 13218,
	"./icon/icon-hic.png": 23652,
	"./icon/icon-human.png": 60886,
	"./icon/icon-invite.png": 90831,
	"./icon/icon-login.png": 98886,
	"./icon/icon-menu.png": 97889,
	"./icon/icon-moves.png": 66085,
	"./icon/icon-pass.png": 44974,
	"./icon/icon-slots.png": 5646,
	"./icon/icon-spins.png": 96005,
	"./icon/icon-star-fill.png": 66436,
	"./icon/icon-star.png": 71923,
	"./icon/icon-star2.png": 89626,
	"./icon/icon-telegram.png": 63177,
	"./icon/icon-time.png": 87772,
	"./icon/icon-ton.png": 35048,
	"./icon/icon-twitter.png": 39457,
	"./icon/icon-up.png": 41868,
	"./icon/icon-usdt.png": 84138,
	"./index-bg.jpg": 3954,
	"./loading-bg.jpg": 29093,
	"./login-sign.jpg": 90018,
	"./logo.jpg": 69218,
	"./lucky-bg.jpg": 87911,
	"./lucky-icon-airdrop.jpg": 30640,
	"./lucky-icon-botcode.jpg": 29209,
	"./lucky-icon-gift.jpg": 86240,
	"./lucky-icon-lucky.jpg": 2810,
	"./lucky-icon-mathine.jpg": 70266,
	"./lucky-icon-minibot.jpg": 22454,
	"./lucky/lucky-8-item-1.png": 85746,
	"./lucky/lucky-8-item-2.png": 79475,
	"./lucky/lucky-bg.png": 27200,
	"./lucky/lucky-btn1-bg.png": 16436,
	"./lucky/lucky-btn1-text.png": 81615,
	"./lucky/lucky-page-bg.jpg": 43459,
	"./mUpgrade-item-bg.png": 93059,
	"./machine/machine-arrow.png": 17409,
	"./machine/machine-bg.png": 69303,
	"./machine/machine-btn1-bg.png": 37724,
	"./machine/machine-main-bg.png": 71890,
	"./machine/machine-page-bg.jpg": 56769,
	"./minibot/minibot-bg.jpg": 45706,
	"./minibot/minibot-store.png": 37087,
	"./minibot/minibot-store1.png": 92968,
	"./minibot/pet-bg.jpg": 40896,
	"./multiple-img.png": 6682,
	"./pass/pass-bg.jpg": 43280,
	"./pass/pass-progree-item-active.png": 18593,
	"./pass/pass-progree-item.png": 15304,
	"./pass/pass-way-bg.jpg": 39223,
	"./rank-1.png": 67023,
	"./rank-2.png": 99933,
	"./rank-3.png": 56036,
	"./reward-bg.jpg": 91835,
	"./rewardAnim/anim-1.png": 58044,
	"./rewardAnim/anim-2.png": 36753,
	"./rewardAnim/anim-bg-COIN.png": 62208,
	"./ris/ris-a-img.png": 6029,
	"./ris/ris-c-img-1.png": 65437,
	"./ris/ris-c-img-2.png": 96199,
	"./turmp.png": 47334,
	"./upgrade-bot-bg.jpg": 57835,
	"./upgrade-bot-bg2.jpg": 48665,
	"./upgrade-box.png": 12327
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90990;